import React from 'react';
// import { SvgIcon } from '@components';
import { HStack } from 'components/muiComponents/stack';
import styled from 'styled-components';
import activeStep from 'assets/images/active-step.svg';

const FilledCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #c21b17;
  margin: 6px;
`;

const EmptyCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #cccccc;
  margin: 2px;
`;

const EmptyBigCircle = styled(EmptyCircle)`
  width: 16px;
  height: 16px;
  background-color: #c21b17;
`;

const Line = styled.div`
  height: 2px;
  flex: 1;
  background-color: #c21b17;
`;

const StepLineContainer = styled(HStack)`
  align-items: center;
  flex: 1;
`;

const LastStepLineContainer = styled.div``;

interface StepIconProps {
  stepCount?: number;
  stepNum?: number;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  isCompletedStep?: boolean;
  isActiveStep?: boolean;
}

const StepIcon = (props: StepIconProps) => {
  const buildRightLine = () => {
    if (props.isCompletedStep) {
      return <Line />;
    }

    return <Line style={{ backgroundColor: '#D3D3D3' }} />;
  };

  const StepIcon = () => {
    if (props.isActiveStep && !props.isCompletedStep) {
      return <img src={activeStep} width="16" height="16" style={{ border: 'none' }} />;
    } else if (props.isLastStep && props.isCompletedStep) {
      return <EmptyBigCircle />;
    } else if (props.isCompletedStep) {
      return <FilledCircle />;
    }

    return <EmptyCircle />;
  };

  const StepLine = () => {
    return (
      <>
        <StepIcon />
        {!props.isLastStep && <>{buildRightLine()}</>}
      </>
    );
  };

  return props.isLastStep == false ? (
    <StepLineContainer {...props}>
      <StepLine />
    </StepLineContainer>
  ) : (
    <LastStepLineContainer>
      <StepIcon />
    </LastStepLineContainer>
  );
};

export default StepIcon;
